import { render, staticRenderFns } from "./SubStatusBubble.vue?vue&type=template&id=65bff8b1&scoped=true"
import script from "./SubStatusBubble.vue?vue&type=script&lang=js"
export * from "./SubStatusBubble.vue?vue&type=script&lang=js"
import style0 from "./SubStatusBubble.vue?vue&type=style&index=0&id=65bff8b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bff8b1",
  null
  
)

export default component.exports